import { z } from 'zod';

import { categoryQuerySchema, courseQuerySchema } from '@/_containers/assessment';
import { practiceExamSchema } from '@/_other-pages/practice-exams/@shared';

export const practiceExamFormSchema = practiceExamSchema
  .omit({
    course_id: true,
    course_name: true,
    description: true,
    image_url: true,
    is_child: true,
    parent: true,
    price: true,
  })
  .extend({
    category: z.array(categoryQuerySchema),
    course: courseQuerySchema.refine((v) => v.id !== '', {
      message: 'Course is required',
    }),
    is_child: z.boolean(),
    name: z.string().min(3, {
      message: 'Assessment name is required',
    }),
    parent_id: z.number(),
    max_total_questions: z.number(),
    total_question: z.coerce.number().min(1, {
      message: 'Total question must be at least 1',
    }),
  })
  .refine(
    ({ max_total_questions, total_question }) => {
      if (total_question > max_total_questions) {
        return false;
      }
      return true;
    },
    { path: ['total_question'], message: 'Total question must be less than or equal to  total questions' }
  );
export type PracticeExamFormSchema = z.infer<typeof practiceExamFormSchema>;
